export const ID_AIRPORT = "AIRPORT";
export const ID_STATION ="STATION";
export const ID_CREDITAGRICOLE ="CREDITAGRICOLE";